import React from 'react';
import './EmptyState.css';

/**
 * Consistent empty-state block.
 *   <EmptyState
 *     icon="📦"
 *     title="No products yet"
 *     description="Add your first product to get started."
 *     action={<Link to="/admin/products" className="btn">Add product</Link>}
 *   />
 */
export default function EmptyState({ icon, title, description, action, compact = false }) {
  return (
    <div className={`empty-state${compact ? ' empty-state--compact' : ''}`} role="status">
      {icon && <div className="empty-state__icon" aria-hidden="true">{icon}</div>}
      {title && <h3 className="empty-state__title">{title}</h3>}
      {description && <p className="empty-state__desc">{description}</p>}
      {action && <div className="empty-state__action">{action}</div>}
    </div>
  );
}
